import { useTranslation } from 'react-i18next';

interface PlaceholderPageProps {
  titleKey: string;
}

const PlaceholderPage = ({ titleKey }: PlaceholderPageProps) => {
  const { t } = useTranslation();

  return (
    <div className='placeholder-page'>
      <h1 className='placeholder-page__title'>{t(titleKey)}</h1>
      <p className='placeholder-page__subtitle'>{t('text_coming_soon')}</p>
    </div>
  );
};

export default PlaceholderPage;
